import React from 'react';
import PropTypes from 'prop-types';
import styles from './CTA.module.scss';

const CTA = ({ data, onClick }) => {

    const { icon, label, color, href, newTab, round, id } = data;

    if(!href){
      return (
        <button aria-pressed="false" id={id} className={`${icon ? styles[icon] : ""}  ${color ? styles[color] : ""} ${styles.cta} common--cta`} onClick={onClick}>
         {label ? label : ""}
        </button>
      )
    }

    return (
      <a href={href ? href : ""} target={newTab ? "_blank" : ""} id={id} className={`${icon ? styles[icon] : ""} ${color ? styles[color] : ""} ${styles.cta} ${round ? styles.round : ""} common--cta`} onClick={onClick}>
       {label ? label : ""}
      </a>
    )
};

CTA.propTypes = {
  data: PropTypes.object
};

CTA.defaultProps = {
  data: {
    href: "#",
    icon: null,
    color: "black",
    label: "Learn More",
    newTab: true,
    bold: false,
    id: null
  }
}

export default CTA;
